import TrainingKitsImg from "../../../assets/used-images/training-kits-img.png";
import Breadcrumb from '../Breadcrumb';
import TrainingKitServiceBox from '../../training-kits-components/ServiceBox';
import ServiceApplyBtn from '../../ui/ServiceApplyBtn';
import { useTranslation } from "react-i18next";

const TrainingKits = () => {
  const { t } = useTranslation();
  const services = t('kits.services', { returnObjects: true });
  return (
    <>
      <Breadcrumb pages={[t('routes.services'), t('routes.training-kits')]} />
      <main className="container">
        <section className='grid grid-cols-[65%_34%] items-center gap-3 p-1 max-lg:grid-cols-1'>
          <div className='border-2 border-dashed p-4 space-y-4 text-start rounded-lg h-full'>
            <p className='services-header after:-bottom-1 after:w-1/2'>
              {t('kits.title')}
            </p>
            <article className='text-common-text text-lg'>
              {t('kits.desc')}
            </article>
          </div>
          <div className='h-72'>
            <img src={TrainingKitsImg} alt="training-kits" className='object-cover w-full h-full rounded-md' />
          </div>
        </section>
        <section className='space-y-8'>
          <div className='flex justify-center w-full'>
            <p className='services-header after:-bottom-1'>
              {t('kits.what')}
            </p>
          </div>
          <div className='grid grid-cols-2 max-lg:grid-cols-1 gap-5'>
            {
              services.map((service, i) => (
                <TrainingKitServiceBox service={service} key={i} />
              ))
            }
          </div>
        </section>
      </main>

      <ServiceApplyBtn serviceId={3} serviceName={t('routes.training-kits')} />

    </>
  );
};

export default TrainingKits;